import type { CSSProperties } from 'react';

import { cn } from '@/utils/cn';

/**
 * A loading placeholder shaped like the content it replaces, so the page does not
 * jump when the data lands.
 *
 * `aria-hidden` with a busy region around it: a screen reader should hear "loading",
 * once, not a description of six grey rectangles.
 */
export const Skeleton = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => (
  <div
    aria-hidden
    style={style}
    className={cn('animate-pulse rounded-md bg-surface-sunken', className)}
  />
);

export const SkeletonText = ({
  lines = 3,
  className,
}: {
  lines?: number;
  className?: string;
}) => (
  <div className={cn('space-y-2', className)}>
    {Array.from({ length: lines }, (_, index) => (
      <Skeleton
        key={index}
        // The last line is short, the way a paragraph ends. Uniform bars read as a
        // table, and the eye notices the difference before the mind does.
        className={cn('h-4', index === lines - 1 ? 'w-2/3' : 'w-full')}
      />
    ))}
  </div>
);
